<template>
  <button class="invoice-button" :class="{'invoice-button__disabled': disabled}" :disabled="disabled" @click="handleButtonClick">
    {{text}}
  </button>
</template>

<script>


export default {
  name: 'InvoiceButton',
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    text:{
      type: String,
      required: false,
    }
  },
  methods:{
    handleButtonClick(e){
      this.$emit('handleButtonClick',e)
    }
  }
}
</script>


<style lang="scss" scoped>
.invoice-button{
  width: 622px;
  height: 96px;
  background: #FFFFFF;
  border-radius: 48px;
  border: 2px solid #FF6A39;
  line-height: 94px;
  font-weight: 500;
  color: #FF6A39;
  text-align: center;
  outline: none;
}
.invoice-button__disabled{
  color: #CFCFCF;
  border: 2px solid #CFCFCF;
}
</style>